/** Schedule tab view mode (agenda / day / week / month). */
export type ScheduleViewMode = 'agenda' | 'daily' | 'weekly' | 'monthly';

export type ScheduleItem = {
  id: string;
  title: string;
  date: string; // ISO date string
  view: ScheduleViewMode;
  kind?: 'event' | 'reminder' | 'teacherBlock' | 'appointment' | 'meeting';
  courseId?: string;
  assignmentId?: string;
  notes?: string;
  time?: string;
  endTime?: string;
  recurrence: 'once' | 'daily' | 'weekly' | 'monthly';
};

/** Local calendar YYYY-MM-DD (matches schedule cursor / date inputs). */
export function formatLocalYMD(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export type ScheduleUndoEntry = {
  item: ScheduleItem;
  atIndex: number;
  expiresAt: number;
};
